<div class="container-fluid p-2 p-md-3 p-lg-4 mt-1">
    <div class="row justify-content-end mb-1" style="position: relative;">

        <!-- FILTERS -->
        <div class="col-12 d-none d-md-inline text-end responsiveColumn">
            <mat-chip-listbox class="mat-chip-container" multiple>
                <mat-chip-option (selectionChange)="onSelectionChange($event, 2)" [selected]="filterStatus.closed">
                    <span>
                        {{"TICKET.LIST.CLOSEDFILTER" | translate}}
                    </span>
                </mat-chip-option>
                <mat-chip-option (selectionChange)="onSelectionChange($event, 1)" [selected]="filterStatus.open">
                    <span>
                        {{"TICKET.LIST.OPENEDFILTER" | translate}}
                    </span>
                </mat-chip-option>
                <!-- <mat-chip-option (selectionChange)="onSelectionChange($event)" selected>
                    <span class="d-none d-md-inline">
                        {{"TICKET.LIST.WORKINGFILTER" | translate}}
                    </span>
                    <i class="bi bi-x-octagon ms-1"></i>
                </mat-chip-option> -->
            </mat-chip-listbox>
        </div>
        <div class="col-12 d-md-none">
            <div class="mt-5"></div>
        </div>
    </div>

    <div class="row justify-content-center mt-2">
        <div class="col-12">
            <div class="table-container">
                <table mat-table [dataSource]="dataSource" matSort class="mat-table"
                    style="border: 1px solid lightgray;">

                    <!-- Id -->
                    <ng-container matColumnDef="idticket">
                        <th class="text-center d-none d-lg-table-cell" mat-header-cell *matHeaderCellDef style="max-width: 50px;">
                            {{"TICKET.LIST.ID" | translate}} </th>
                        <td class="text-center d-none d-lg-table-cell" mat-cell *matCellDef="let element"
                            style="max-width: 50px; padding-left: 0.5rem; padding-right: 0.5rem;">
                            {{ element.idticket }}
                        </td>
                    </ng-container>

                    <!-- Progressive -->
                    <ng-container matColumnDef="progressive">
                        <th class="text-center d-none d-lg-table-cell" mat-header-cell *matHeaderCellDef
                            style="max-width: 76px; padding-left: 0.2rem; padding-right: 0.2rem;">
                            {{"TICKET.LIST.PROGRESSIVE" | translate}}
                        </th>
                        <td class="text-center d-none d-lg-table-cell" mat-cell *matCellDef="let element" style="max-width: 76px;">
                            {{ element.progressive }}
                        </td>
                    </ng-container>

                    <!-- Opening Date -->
                    <ng-container matColumnDef="ticket_date">
                        <th class="text-center d-none d-md-table-cell" mat-header-cell *matHeaderCellDef mat-sort-header
                            style="max-width: 90px; padding-left: 0.2rem; padding-right: 0.2rem;">
                            {{"TICKET.LIST.CREATIONDATE" | translate}}
                        </th>
                        <td class="text-center d-none d-md-table-cell" mat-cell *matCellDef="let element" style="max-width: 90px;">
                            {{ element.ticket_date | date:(currentLanguage === 'it' ? 'dd/MM/yyyy' : 'yyyy-MM-dd') }}
                        </td>
                    </ng-container>

                    <!-- Description -->
                    <ng-container matColumnDef="description">
                        <th class="text-center" mat-header-cell *matHeaderCellDef style="max-width: 280px;">
                            {{"TICKET.LIST.DESCRIPTION" | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element"
                            style="max-width: 280px; padding-left: 0.4rem; padding-right: 0.4rem;">
                            <div class="truncate-text">
                                {{element.description}}
                            </div>
                        </td>
                    </ng-container>

                    <!-- Ticket Status -->
                    <ng-container matColumnDef="ticketStatus">
                        <th class="text-center" mat-header-cell *matHeaderCellDef> {{"TICKET.LIST.STATUS" | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element.ticketStatus != null; else noStatusBlock">
                                <i class="bi bi-circle-fill" [ngStyle]="{'color': element.ticketStatus.color}"></i>
                                {{ element.ticketStatus.name_status }}
                            </ng-container>
                            <ng-template #noStatusBlock>
                                {{"TICKET.LIST.NOSTATUS" | translate}}
                            </ng-template>
                        </td>
                    </ng-container>

                    <!-- Header & Rows -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr class="rowHover" mat-row *matRowDef="let row; columns: displayedColumns;"
                        (click)="goToTicket(row.idticket)"></tr>
                </table>
            </div>
        </div>
    </div>
</div>
